module.exports = __webpack_public_path__ + "assets/img/star-2.e478d9d7.svg";